import React, { useMemo } from "react";

import { TeaserLayoutWrapper } from "../../../components/teaser-components/TeaserLayoutWrapper/TeaserLayoutWrapper";
import { TeaserView } from "./TeaserView/TeaserView";

export function ContentTeaser({
    data: {
        anker,
        tagline,
        display,
        headline,
        background,
        semanticOfHeadline,
        semanticOfTeaserHeadline,
        subheadline,
        teaser = [],
        link
    },
    hasLightBackground
}) {
    const teaserList = useMemo(
        () =>
            teaser
                /**
                 * For DatoCmsTeaser the fields teaserText and teaserLink are named differently due to issues with GraphQL.
                 * With this mapping we store the values back into teaserText and teaserLink to fit the same structure as
                 * all the other teasers.
                 */
                .map(
                    ({
                        contentTeaserLink,
                        contentTeaserText,
                        fairTeaserUrl,
                        teaserLink,
                        teaserText,
                        teaserUrl,
                        externalUrl,
                        ...rest
                    }) => ({
                        teaserLink: teaserLink || contentTeaserLink,
                        teaserText: teaserText || contentTeaserText,
                        teaserUrl: teaserUrl || fairTeaserUrl || externalUrl,
                        ...rest
                    })
                )
                /**
                 * add "links" property to "teaserLink" if it doesn't exist
                 * this is done because it can't be achieved using a graphql query, the reason being:
                 *  - different types have different structures for the "teaserLink" field
                 *  - not selecting the "links" prop in the query prevents the issue
                 *    but the StructuredTextRenderer will complain about the missing "links" property
                 */
                .map(({ teaserLink, ...t }) => ({
                    ...t,
                    teaserLink: teaserLink
                        ? {
                              ...teaserLink,
                              links: teaserLink?.links || []
                          }
                        : undefined
                })),
        [teaser]
    );

    return (
        <TeaserLayoutWrapper
            anker={anker}
            tagline={tagline}
            headline={headline}
            subheadline={subheadline}
            semanticOfHeadline={semanticOfHeadline}
            background={background}
            hasLightBackground={hasLightBackground}
            link={link}
        >
            <TeaserView
                teaser={teaserList}
                display={display}
                semanticOfTeaserHeadline={semanticOfTeaserHeadline}
                hasLightBackground={hasLightBackground}
            />
        </TeaserLayoutWrapper>
    );
}
